import React from 'react';
import Gallery from '../components/Gallery';
import { 
  photoVideographyImages,
  prePostWeddingImages,
  fashionShootImages,
  corporateEventsImages,
  babyShootsImages,
  adsImages,
  podcastImages,
  filmMakingImages
} from '../data/images';

const Portfolio = () => {
  // Combine all images for portfolio showcase
  const allImages = [
    ...photoVideographyImages.slice(0, 2),
    ...prePostWeddingImages.slice(0, 2),
    ...fashionShootImages.slice(0, 2),
    ...corporateEventsImages.slice(0, 2),
    ...babyShootsImages.slice(0, 2),
    ...adsImages.slice(0, 2),
    ...podcastImages.slice(0, 2),
    ...filmMakingImages.slice(0, 2)
  ];

  return (
    <div className="portfolio-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Portfolio</h1>
          <p>
            A curated collection of our finest work across all photography genres. 
            From intimate moments to grand celebrations, we capture life's most precious memories.
          </p>
        </div>
      </section>
      <Gallery images={allImages} title="Featured Work" sectionId="portfolio-featured" />
      
      <section className="gallery-section">
        <div className="container">
          <h2 className="gallery-title">Our Specialties</h2>
          <div className="gallery-grid">
            <div className="gallery-item wedding-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Photography & Videography
              </div>
            </div>
            <div className="gallery-item event-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Pre & Post Wedding
              </div>
            </div>
            <div className="gallery-item portrait-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Fashion Shoots
              </div>
            </div>
            <div className="gallery-item nature-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Corporate Events
              </div>
            </div>
            <div className="gallery-item birthday-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Baby Shoots
              </div>
            </div>
            <div className="gallery-item event-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Advertising Photography
              </div>
            </div>
            <div className="gallery-item portrait-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Podcast Production
              </div>
            </div>
            <div className="gallery-item nature-bg">
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                Film Making
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
